/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_New_PackagesInputs */

const en_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New lesson packages`)
};

const es_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevos paquetes de lecciones`)
};

const de_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Unterrichtspakete`)
};

const zh_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新课程套餐`)
};

const ar_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`باقات دروس جديدة`)
};

const fr_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveaux forfaits de cours`)
};

const vi_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói buổi học mới`)
};

const sw_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vifurushi vipya vya somo`)
};

const th_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็คเกจบทเรียนใหม่`)
};

const bs_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novi paketi lekcija`)
};

const ja_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいレッスンパッケージ`)
};

const ko_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 레슨 패키지`)
};

const pt_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novos pacotes de aulas`)
};

const it_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovi pacchetti di lezioni`)
};

const sv_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nya lektionspaket`)
};

const nl_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe lespakketten`)
};

const da_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nye undervisningspakker`)
};

const nb_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nye leksjonspakker`)
};

const fi_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uudet oppituntipaketit`)
};

const pl_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowe pakiety lekcji`)
};

const ru_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новые пакеты уроков`)
};

const tr_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni ders paketleri`)
};

const hi_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नए पाठ पैकेज`)
};

const id_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket pelajaran baru`)
};

const ms_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakej pelajaran baharu`)
};

const cs_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nové výukové balíčky`)
};

const el_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νέα πακέτα μαθημάτων`)
};

const he_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חבילות שיעורים חדשות`)
};

const af_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuwe lespakkette`)
};

const hu_booking_new_packages = /** @type {(inputs: Booking_New_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új tanítási csomagok`)
};

/**
* | output |
* | --- |
* | "New lesson packages" |
*
* @param {Booking_New_PackagesInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_new_packages = /** @type {((inputs?: Booking_New_PackagesInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_New_PackagesInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_new_packages(inputs)
	if (locale === "de") return de_booking_new_packages(inputs)
	if (locale === "zh") return zh_booking_new_packages(inputs)
	if (locale === "ar") return ar_booking_new_packages(inputs)
	if (locale === "fr") return fr_booking_new_packages(inputs)
	if (locale === "vi") return vi_booking_new_packages(inputs)
	if (locale === "sw") return sw_booking_new_packages(inputs)
	if (locale === "th") return th_booking_new_packages(inputs)
	if (locale === "bs") return bs_booking_new_packages(inputs)
	if (locale === "ja") return ja_booking_new_packages(inputs)
	if (locale === "ko") return ko_booking_new_packages(inputs)
	if (locale === "pt") return pt_booking_new_packages(inputs)
	if (locale === "it") return it_booking_new_packages(inputs)
	if (locale === "sv") return sv_booking_new_packages(inputs)
	if (locale === "nl") return nl_booking_new_packages(inputs)
	if (locale === "da") return da_booking_new_packages(inputs)
	if (locale === "nb") return nb_booking_new_packages(inputs)
	if (locale === "fi") return fi_booking_new_packages(inputs)
	if (locale === "pl") return pl_booking_new_packages(inputs)
	if (locale === "ru") return ru_booking_new_packages(inputs)
	if (locale === "tr") return tr_booking_new_packages(inputs)
	if (locale === "hi") return hi_booking_new_packages(inputs)
	if (locale === "id") return id_booking_new_packages(inputs)
	if (locale === "ms") return ms_booking_new_packages(inputs)
	if (locale === "cs") return cs_booking_new_packages(inputs)
	if (locale === "el") return el_booking_new_packages(inputs)
	if (locale === "he") return he_booking_new_packages(inputs)
	if (locale === "af") return af_booking_new_packages(inputs)
	if (locale === "hu") return hu_booking_new_packages(inputs)
	return en_booking_new_packages(inputs)
});